import makeCrud from '@/store/site/localization/crud'

// Sepet linki CRUD'u standart sayfalı liste sözleşmesini (data + meta) kullanır;
// items/kupon/kanal dahil payload'ı sayfa oluşturur → ortak CRUD store fabrikası yeterli.
export default makeCrud('ecommerce_cart_link')
